import { signals2DToZ } from '../signals/signals2DToZ';
import { signalsToXY } from '../signals/signalsToXY';
import { getFrequency } from '../utilities/getFrequency';
import { predict } from './predict';
export async function predictSpectra(molecule, options = {}) {
    const { logger, simulation: simulationOptions = { oneD: {}, twoD: {} }, prediction: predictOptions = {}, } = options;
    const { spectra } = await predict(molecule, { logger, ...predictOptions });
    const oneDOptions = {
        ...{
            proton: { from: 0, to: 14 },
            carbon: { from: 0, to: 200 },
            nbPoints: 65536,
            frequency: 400,
            lineWidth: 1,
        },
        ...(simulationOptions.oneD || {}),
    };
    const twoDOptions = {
        ...{
            from: { x: oneDOptions.proton.from, y: oneDOptions.carbon.from },
            to: { x: oneDOptions.proton.to, y: oneDOptions.carbon.to },
            nbPoints: { x: 1024, y: 1024 },
        },
        ...(simulationOptions.twoD || {}),
    };
    if (!('frequency' in simulationOptions) && logger) {
        logger.warn(`Frequency is settled to 400 MHz`);
    }
    const { frequency = 400 } = simulationOptions;
    const newSpectra = [];
    for (const experiment in spectra) {
        switch (experiment) {
            case 'carbon':
            case 'proton': {
                newSpectra.push(get1DSpectrum(spectra[experiment], {
                    nbPoints: oneDOptions.nbPoints,
                    lineWidth: oneDOptions.lineWidth,
                    ...oneDOptions[experiment],
                    experiment,
                    frequency,
                }));
                break;
            }
            case 'cosy':
            case 'hsqc':
            case 'hmbc': {
                newSpectra.push(get2DSpectrum(spectra[experiment], {
                    ...twoDOptions,
                    experiment,
                    frequency,
                }));
                break;
            }
            default:
                break;
        }
    }
    return {
        spectra: newSpectra,
        molecules: [{ molfile: molecule.toMolfile() }],
    };
}
function get2DSpectrum(prediction, options) {
    const { signals, zones, nuclei } = prediction;
    const { frequency: baseFrequency, experiment } = options;
    const width = get2DWidth(nuclei);
    const frequency = calculateFrequency(nuclei, baseFrequency);
    const minMaxContent = signals2DToZ(signals, {
        ...options,
        width,
        factor: 3,
    });
    const spectrum = {
        data: { rr: { ...minMaxContent, noise: 0.01 } },
        info: {
            nucleus: nuclei,
            originFrequency: frequency,
            baseFrequency: frequency,
            pulseSequence: experiment,
            experiment: '2d',
        },
        zones: { values: zones },
    };
    return spectrum;
}
function get2DWidth(nucleus) {
    return nucleus[0] === nucleus[1] ? 0.02 : { x: 0.02, y: 0.2133 };
}
function get1DSpectrum(prediction, options) {
    const { frequency = 400, experiment } = options;
    const { signals, nucleus } = prediction;
    const realFrequency = calculateFrequency(nucleus, frequency);
    const { x, y } = signalsToXY(signals, {
        ...options,
        frequency: realFrequency,
    });
    const spectrum = {
        // todo Array.from is temporary for the developement
        data: { x: Array.from(x), re: Array.from(y), im: null },
        info: {
            nucleus: prediction.nucleus,
            dimension: 1,
            isComplex: false,
            originFrequency: realFrequency,
            baseFrequency: realFrequency,
            pulseSequence: 'prediction',
            experiment,
            isFt: true,
        },
        ranges: { values: prediction.ranges },
    };
    return spectrum;
}
function calculateFrequency(nucleus, frequency) {
    if (typeof nucleus === 'string') {
        return getFrequency(nucleus, { nucleus: '1H', frequency });
    }
    else if (nucleus[0] === nucleus[1]) {
        return `${frequency},${frequency}`;
    }
    else {
        return `${frequency},${getFrequency(nucleus[1], {
            nucleus: nucleus[0],
            frequency,
        })}`;
    }
}
//# sourceMappingURL=predictSpectra.js.map